import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod/dist/zod.js";
import * as zod from "zod";
import { Button } from "../../../components/button.jsx";
import { TabsGroup } from "../../../components/tabsGroup.jsx";
import { LoaderFiller } from "../../../components/loaderFiller.jsx";
import * as PropTypes from "prop-types";
import { InfoTab } from "./contactEditPage/infoTab.jsx";
import { useSelector } from "react-redux";
import { DocumentsTab } from "./contactEditPage/documentsTab.jsx";
import { useResource } from "../../../hooks/useResource.js";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";

export let CONTACT_EDIT_PANEL = "editContact";

InfoTab.propTypes = { control: PropTypes.any };

DocumentsTab.propTypes = {
  watch: PropTypes.func,
  setValue: PropTypes.func,
};

export function ContactEditPage() {
  let { id: contactId } = useParams();

  let session = useSelector((state) => state.session);
  let contactsService = useResource("contacts");

  let navigate = useNavigate();

  const onRemove = () => {
    return contactsService.delete(contactId).then(() => {
      navigate("/contacts");
    });
  };
  const onSave = (d) => {
    return contactsService.edit(contactId, d).then((newContact) => {
      if (contactId === "new") {
        navigate(`/contacts/${newContact.id}`, { replace: true });
      } else {
        reset(newContact);
      }
    });
  };

  let { control, handleSubmit, formState, watch, setValue, reset } = useForm({
    resolver: zodResolver(
      zod.object({
        firstName: zod.string().nullish(),
        lastName: zod.string().nullish(),
        company: zod.string().nullish(),
        website: zod.string().nullish(),
        email: zod.string().nullish(),
        phone: zod.string().nullish(),
        number: zod.string().nullish(),
        street: zod.string().nullish(),
        city: zod.string().nullish(),
        zip: zod.string().nullish(),
        country: zod.string().nullish(),
        vatNumber: zod.string().nullish(),
        notes: zod
          .array(
            zod.object({
              when: zod.string(),
              content: zod.string(),
              id: zod.string(),
            })
          )
          .nullish(),
        documents: zod
          .array(
            zod
              .object({
                type: zod.string(),
                id: zod.number(),
              })
              .passthrough()
          )
          .nullish(),
      })
    ),
  });

  useEffect(() => {
    if (contactId !== "new") {
      contactsService.get(contactId).then((res) => reset(res));
    } else {
      reset({ id: "new" });
    }
  }, [contactId]);

  return (
    <div className={"flex gap-3 flex-col h-full p-3"}>
      <div className={"flex gap-3"}>
        <h2 className={"font-bold py-2 flex items-center flex-grow"}>
          Contact
        </h2>

        <Button type={"link"} to={"/contacts"}>
          <span className={"fa fa-arrow-left"} />{" "}
        </Button>
      </div>

      <form
        onSubmit={handleSubmit((d) => {
          return onSave(d);
        })}
        className={"flex flex-col gap-3 overflow-auto relative"}
      >
        {!watch("id") && <LoaderFiller />}
        <TabsGroup
          tabs={[
            {
              label: "Info",
              icon: "pen",
              component: <InfoTab control={control} />,
            },

            {
              label: `Documents (${(watch("documents") || []).length})`,
              icon: "file-invoice",
              component: <DocumentsTab watch={watch} setValue={setValue} />,
            },
          ]}
          afterTabs={
            <>
              {" "}
              <Button
                type={"submit"}
                onClick={handleSubmit((d) => {
                  onSave(d);
                })}
                variant={
                  Object.keys(formState.dirtyFields).length
                    ? "danger"
                    : "primary"
                }
              >
                Save
              </Button>
              <Button type={"button"} variant={"alert"} onClick={onRemove}>
                Delete
              </Button>
            </>
          }
        />
        <input type={"submit"} className={"hidden"} />
      </form>
    </div>
  );
}
